// Switch — controlled on/off. Slides the knob; colour = brand when on.
export function Toggle({ on, onChange, "aria-label": ariaLabel, disabled = false }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange && onChange(!on)}
      className={`bz-toggle${on ? " bz-toggle--on" : ""}`}
    >
      <span className="bz-toggle__knob" />
    </button>
  );
}
